export const feeLevelMap = {
  slow: 1,
  middle: 2,
  fast: 3,
};

export const chainNameByChainCodeMap: Record<string, string> = {
  GETH: 'Ethereum',
  ETH: 'Ethereum',
  BSC: 'BNB Chain',
  MATIC: 'Polygon',
  OP: 'Optimism',
  CAVAX: 'Avalanche C',
  ARBI: 'Arbitrum',
  FTM: 'Fantom',
};
